export default "__VITE_ASSET__3Q4OaXJd__$_?url__"